import { Size } from '@ps/web-core-store';
import { StarsButton } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { Dispatch } from '@swf/core/store';

import BaseHeader from '../../components/Modal/BaseHeader/BaseHeader';
import { useWidgetTheme } from '../../hooks';

import { TXTCLI_OK } from './PresentationalSizes.messages.json';
import styles from './PresentationalSizes.scss';

const PresentationalSizes: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { size } = useSearchParams<{ size: Size }>();
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const { className } = useWidgetTheme();

  useEffect(() => {
    setStyle({
      overlayClassName: classNames(className, styles.modalOverlay),
      className: classNames(styles.modalContainer, styles.modalContainerCentered),
      closeOnOverlayClick: true,
      closeOnEsc: true,
      size: size || Size.MEDIUM
    });
  }, [className, setStyle, size]);

  return (
    <div>
      <BaseHeader headerClassName={styles.header} title="Modal Sizes" />
      <div className={styles.body}>
        <p>Presentational component for the Modal Sizes</p>
        <StarsButton onClick={() => modal.close()} translation={TXTCLI_OK} />
      </div>
    </div>
  );
};

export default PresentationalSizes;
